const config = {
  GATSBY_CONTACT_FORM_KEEP_KEY: "5544a8ff75b9",
  GATSBY_CARRER_FORM_KEEP_KEY: "80374aa886f2",
  GATSBY_HIRE_ROR_FORM_KEEP_KEY: "95cc01e2748b",
  RECAPTCHA_SITE_KEY: "6LdtPuMpAAAAAFSin9h2o3l60VXEDIiF3uc_aQc4",
  RECAPTCHA_SITE_SECRET_URL: "captcha.railsfactory.com"
};

export default config;
